import { render, staticRenderFns } from "./pageHead.vue?vue&type=template&id=147f8081&"
import script from "./pageHead.vue?vue&type=script&lang=js&"
export * from "./pageHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports